import { List } from 'antd'
import { ListProps } from 'antd/lib/list'
import KInfoRow from 'app/components/Modules/DataDisplay/KInfoRow'
import { ComplexRecord, SimpleRecord } from 'app/components/Modules/DataDisplay/typing'
import KList from 'app/components/Modules/List/KList'
import { ReactNode } from 'react'

interface CommonProps extends ListProps<Record<string, unknown>> {
  recordType: string
  translateAttributes?: boolean
}

interface WithIconProps {
  member: SimpleRecord
}

interface WithoutIconProps {
  member: ComplexRecord
}

function KInfo(props: CommonProps & (WithIconProps | WithoutIconProps)) {
  const { member, recordType, ...others } = props

  const getValue = (key: string) => {
    if (typeof member[key] === 'object') {
      return (member as ComplexRecord)?.[key]?.value
    } else {
      return (member as SimpleRecord)[key]
    }
  }

  // Do not add recordType as useIndex() fetches data from redux store
  return (
    <KList
      data-testid={[recordType, 'kinfo'].join('-')}
      dataSource={Object.keys(member)}
      renderItem={(key) => (
        <List.Item>
          <KInfoRow
            recordType={recordType}
            attribute={key}
            value={getValue(key) as ReactNode}
            icon={(member as ComplexRecord)?.[key]?.icon}
          />
        </List.Item>
      )}
      {...others}
    />
  )
}

export default KInfo
